<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addController" v-if="permissionCodes.indexOf('') !== -1"/>
      </div>
<!--      <div style="display: flex;justify-content: flex-start">-->
<!--        <input-select selectTitle="设备状态" :selectKey="'deviceStatus'" selectWidth="100px" :selectData="deviceStatusList" @search="search" style="margin-right: 10px"/>-->
<!--      </div>-->
      <input-search placeholder="入住人/入住房间" @search="searchKey" />
    </div>
    <div class="search-line">
      <div class="btn-box">
        <span style="margin-right: 0.06rem">核验时间</span>
        <el-date-picker
          v-model="timeValue"
          :picker-options="pickerOptions2"
          end-placeholder="结束日期"
          range-separator="至"
          size="small"
          start-placeholder="开始日期"
          type="daterange"
          unlink-panels
          value-format="yyyy-MM-dd"
          @change="changeTimeValue">
        </el-date-picker>
      </div>
    </div>
    <table-main
      :selection="false"
      :tableHead="tableHead"
      :tableData="tableData"
      :total="total"
      :pageNum="pageNum"
      :pageSize="pageSize"
      :operationArr="operationArr"
      @checkOut="checkOut"
      @changeSelection="changeSelection"
      @changePagination="changePagination"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/WaterManagement";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "checkInVerification",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {value: "酒店入住", name: "check-in-application"},
        {value: "入驻申请"}
      ],
      addController: "",
      exportUrl: "",
      tableHead: [
        {prop: "personName", label: "核验人"},
        {prop: "applicationTime", label: "核验时间"},
        {prop: "approveName", label: "入住人"},
        {prop: "roomInfoNumber", label: "入住房间"},
        {prop: "cardNum", label: "绑定房卡"},
      ],
      tableData: [
        {
          code: '0111',
          personName: '李四',
          checkTime: '1天',
          roomInfoNumber: '301',
          applicationTime: '2024-03-20 12:20:12',
          statusText: '已通过',
          approveName: '张三',
          cardNum: '12309889'
        },
        // {
        //   code: '0112',
        //   personName: '李四',
        //   checkTime: '1天',
        //   roomInfoNumber: '203',
        //   applicationTime: '2024-03-19 12:20:12',
        //   statusText: '已通过',
        //   approveName: '李思',
        //   cardNum: '12309889'
        // },
        {
          code: '0113',
          personName: '李四',
          checkTime: '1天',
          roomInfoNumber: '315',
          applicationTime: '2024-03-18 12:20:12',
          statusText: '已通过',
          approveName: '王晓',
          cardNum: '12309889'
        },
      ],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      deviceStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "在线"
        },
        {
          key: "0",
          label: "离线"
        }
      ],
      requestData: {
        searchKey: "",
        deviceStatus: ""
      },
      operationArr: ["checkOut"],
      timeValue: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreateTime();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getCreateTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-01";
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },

    changeTimeValue() {
      this.requestData.pageNum = 1;
      this.requestData.pageSize = 10;
      this.getPage();
    },

    // 获取集中器
    getPage() {
      return;
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getWaterControlDevicePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            v.code = v.deviceCode;
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    checkOut() {
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/water_controller_current/${code}`
      });
    },
    deleteLine(code) {
      let codes = code.join(",");
      this.$axios
        .post(api.deleteWaterControlDeviceByCodes, {
          codes
        })
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less" scoped>
.el-input--small .el-input__inner {
  line-height: 30px;
}
/deep/.all-table-class .el-button--text {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/hotelCheckIn/checkInVerification/checkInVerification.vue